import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { AcknowledgeModal, ConfirmationModal, Modal } from '@percent/lemonade'
import { CancelAllReassignmentsModalProps } from './CancelAllReassignmentsModal.types'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation } from '@percent/admin-dashboard/common/hooks'

export function CancelAllReassignmentsModal({
  open,
  onClose,
  refresh,
  sourceOrganisationName,
  organisationId
}: CancelAllReassignmentsModalProps) {
  const { t } = useTranslation()
  const { donationsService } = useServices()

  const [successDialogState, setSuccessDialogState] = useState(false)
  const [errorDialogState, setErrorDialogState] = useState(false)

  const [{ isLoading }, { apiFunc }] = useMutation(
    donationsService.cancelAllReassignments,
    () => setSuccessDialogState(true),
    () => setErrorDialogState(true)
  )

  const handleCloseModal = () => {
    onClose()
    refresh()
    setSuccessDialogState(false)
  }

  const handleOnErrorClose = () => {
    setErrorDialogState(false)
  }

  const handleSubmit = async () => {
    await apiFunc({
      organisationId
    })
  }

  const successOrErrorModal = successDialogState ? (
    <AcknowledgeModal
      result="positive"
      title={t('dialog.cancelAllReassignments.success.title')}
      buttonText={t('button.close')}
      handleClose={handleCloseModal}
      viewTestId="success-cancel-all-reassignments-modal"
    >
      <Trans
        i18nKey="dialog.cancelAllReassignments.success.description"
        values={{ orgName: sourceOrganisationName }}
        components={{ b: <strong /> }}
      />
    </AcknowledgeModal>
  ) : (
    <AcknowledgeModal
      result="negative"
      title={t('dialog.cancelAllReassignments.error.title')}
      buttonText={t('button.close')}
      handleClose={handleOnErrorClose}
      viewTestId="error-cancel-all-reassignments-modal"
    >
      <Trans
        i18nKey="dialog.cancelAllReassignments.error.description"
        values={{ orgName: sourceOrganisationName }}
        components={{ b: <strong /> }}
      />
    </AcknowledgeModal>
  )

  return (
    <Modal open={open} onClose={handleCloseModal} aria-labelledby="cancel-all-reassignments-modal">
      {!successDialogState && !errorDialogState ? (
        <ConfirmationModal
          title={t('dialog.cancelAllReassignments.confirmation.title')}
          loading={isLoading}
          primaryButtonText={t('button.cancelAllReassignments')}
          primaryBtnTestId="confirm-cancel-all-reassignments"
          secondaryButtonText={t('button.cancel')}
          handleSubmit={handleSubmit}
          handleClose={handleCloseModal}
        >
          <Trans
            i18nKey="dialog.cancelAllReassignments.confirmation.description"
            values={{ orgName: sourceOrganisationName }}
            components={{ b: <strong /> }}
          />
        </ConfirmationModal>
      ) : (
        successOrErrorModal
      )}
    </Modal>
  )
}
